var _defs, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect0, _rect1, _rect10, _rect11, _rect12, _rect13, _g, _path, _path2, _rect14, _path3, _path4, _rect15, _text, _defs2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIosShareStep(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 420,
    height: 250,
    viewBox: "0 0 420 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "bgShare",
    x1: 0,
    y1: 0,
    x2: 420,
    y2: 250,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D1D1D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2C2C2C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "screenShare",
    x1: 0,
    y1: 0,
    x2: 0,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F8FA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ECEFF4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "accentShare",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E6F680"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6BE2E"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 419,
    height: 249,
    rx: 18,
    fill: "url(#bgShare)",
    stroke: "#3E3E3E"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 20,
    width: 150,
    height: 24,
    rx: 12,
    fill: "#101010",
    opacity: 0.55
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 34,
    y: 28,
    width: 62,
    height: 8,
    rx: 4,
    fill: "#858585"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 130,
    y: 18,
    width: 160,
    height: 214,
    rx: 28,
    fill: "#101010"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 138,
    y: 26,
    width: 144,
    height: 198,
    rx: 22,
    fill: "url(#screenShare)"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 190,
    y: 26,
    width: 40,
    height: 5,
    rx: 2.5,
    fill: "#1A1A1A",
    opacity: 0.55
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 148,
    y: 44,
    width: 124,
    height: 22,
    rx: 11,
    fill: "#D9DEE8"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 158,
    y: 51,
    width: 80,
    height: 8,
    rx: 4,
    fill: "#9FA8B8"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 148,
    y: 74,
    width: 52,
    height: 52,
    rx: 10,
    fill: "#C8D1DE"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 74,
    width: 64,
    height: 10,
    rx: 5,
    fill: "#BDC8D6"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 90,
    width: 50,
    height: 10,
    rx: 5,
    fill: "#CBD5E2"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 208,
    y: 106,
    width: 42,
    height: 10,
    rx: 5,
    fill: "#D4DCE6"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 148,
    y: 198,
    width: 124,
    height: 16,
    rx: 8,
    fill: "#D7DDE7"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 146,
    y: 180,
    width: 128,
    height: 34,
    rx: 14,
    fill: "#111111"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 154,
    y: 186,
    width: 112,
    height: 22,
    rx: 11,
    fill: "#2A2A2A"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#shadowShare)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 188,
    y: 183,
    width: 44,
    height: 28,
    rx: 10,
    fill: "url(#accentShare)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M210 190V202",
    stroke: "#3D2E00",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M205 195L210 190L215 195",
    stroke: "#3D2E00",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 202.5,
    y: 200.5,
    width: 15,
    height: 7,
    rx: 2.5,
    stroke: "#3D2E00",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M56 206L116 190",
    stroke: "#E6F680",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M110 183L126 187L117 201",
    fill: "#E6F680"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 28,
    y: 186,
    width: 84,
    height: 42,
    rx: 12,
    fill: "#101010",
    opacity: 0.7
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 70,
    y: 212,
    textAnchor: "middle",
    fill: "#E6F680",
    fontSize: 16,
    fontFamily: "Arial, sans-serif",
    fontWeight: 700
  }, "SHARE")), _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "shadowShare",
    x: 180,
    y: 177,
    width: 60,
    height: 40,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.130 0 0 0 0 0.160 0 0 0 0 0.030 0 0 0 0.55 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_0_1"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_0_1",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIosShareStep);
export default __webpack_public_path__ + "static/media/ios-share-step.859c441d4f47165e44e6ef81333b1822.svg";
export { ForwardRef as ReactComponent };